<div class="panel-t2 {{theme}}" [ngClass]="{ active: active }">
  <div class="d-flex align-items-center">
    <div class="mr-2" *ngIf="icon && iconPosition === 'left'">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </div>
    <div class="mr-2" *ngIf="badge && badgePosition === 'left'">
      <ng-container *ngTemplateOutlet="badgeRender"></ng-container>
    </div>
    <div class="w-auto font-weight-bold {{'fs-' + headingSize}}" *ngIf="heading">
      {{heading}}
    </div>
    <div class="ml-2" *ngIf="icon && iconPosition === 'right'">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </div>
    <div class="ml-2" *ngIf="badge && badgePosition === 'right'">
      <ng-container *ngTemplateOutlet="badgeRender"></ng-container>
    </div>
    <div *ngIf="action" class="flex-noshrink ml-auto">
      <ng-container [ngTemplateOutlet]="action"></ng-container>
    </div>
  </div>
  <div [ngClass]="{ 'mt-3': heading }">
    <ng-content></ng-content>
  </div>
</div>

<ng-template #badgeRender>
  <div class="badge badge-{{badgeTheme}}">{{badge}}</div>
</ng-template>
